import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetOdontoSpecialties,
	GetOdontoSpecialtiesModel,
	GetOdontoSpecialtiesParams,
} from 'domain/usecases';

export class RemoteGetOdontoSpecialties implements GetOdontoSpecialties {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetOdontoSpecialtiesModel>,
	) {}

	async get({signal}: GetOdontoSpecialtiesParams): Promise<GetOdontoSpecialtiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
